'use client';

import * as PhosphorIcons from '@phosphor-icons/react';
import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type PanelTitleProps = {
  children?: ReactNode;
  className?: string;
  icon?: keyof typeof PhosphorIcons;
};

export const PanelTitle: FC<PanelTitleProps> = ({
  children,
  className,
  icon,
}) => {
  const Icon = icon ? (PhosphorIcons[icon] as PhosphorIcons.Icon) : undefined;

  return (
    <h1
      className={twMerge(
        'text-lg font-semibold text-black sm:text-3xl sm:font-extralight',
        'z-0',
        'flex items-center gap-[5px]',
        className,
      )}
    >
      {Icon && <Icon size={25} className="text-primary sm:hidden" />}
      {children}
    </h1>
  );
};
